import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-base-send-wahtsup',
  templateUrl: './base-send-wahtsup.component.html',
  styleUrl: './base-send-wahtsup.component.scss'
})
export class BaseSendWahtsupComponent {
  editId;
  systemMenuId;

  // constructor
  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.editId = data.id;
    this.systemMenuId = data.systemMenuId;
  }

  ngOnInit(): void {
  }

  send() {

  }
}
